export default "__VITE_ASSET__BwvfTFEe__"